import styled from "styled-components";

export const PaginationContainer = styled.div`
  /* Emulate the .paginator class behavior and nested li/a styles */
  .paginator {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;

    & > li {
      list-style: none;
      display: flex;

      & > a {
        align-content: center;
        background-color: #eee;
        color: #ec6726; /* orange-senne */
        font-weight: bold;
        font-size: 14px;
        margin: 0;
        padding: 10px 12px;
        width: auto;
        text-align: center;
        transition: background-color 0.3s, color 0.3s;
        cursor: pointer;

        &:hover {
          background-color: #f3953f; /* orange-hover estimated */
        }
      }

      &.selected > a {
        background-color: #ec6726; /* orange-senne */
        color: #fff;
      }
    }
  }

  @media (max-width: 600px) {
    .paginator > li > a {
      font-size: 11px;
      padding: 8px 10px;
    }
  }
`;
